
import { Component, Prop, Vue } from 'vue-property-decorator';
import { cloneDeep } from 'lodash';
import { validateHTMLColorHex } from 'validate-color';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/validation-rules';

@Component<CustomTheme>({
	components: {
		ValidationObserver,
		ValidationProvider
	}
})
export default class CustomTheme extends Vue {
	@Prop({ type: Object, default: () => {} }) private targetMenuConfig!: MenuConfiguration;

	private value = 0;
	private defaultPrimaryColor: string = '#003366';
	private mutableMenuConfiguration: MenuConfiguration = cloneDeep(this.targetMenuConfig);

	private colorPickerOpened: any = false;
	private displayColor: string = this.mutableMenuConfiguration.primary_color ? this.forceHashPrefix(this.mutableMenuConfiguration.primary_color) : this.defaultPrimaryColor;

	private themeOptions: RadioOptions[] = [
		{ name: this.$t('settings.customize.theme.light_rb_label'), value: 'light', option: 1 },
		{ name: this.$t('settings.customize.theme.dark_rb_label'), value: 'dark', option: 2 }
	];
	private themeOptionSelected: number = 0;

	private created(): void {
		// default theme is light
		this.themeOptionSelected = this.mutableMenuConfiguration.theme === 'dark' ? 2 : 1;
	}

	private changeTheme(): void {
		const themeValue = this.themeOptions.filter((themeOption: any) => themeOption.option === this.themeOptionSelected)[0].value!.toString().toLowerCase();
		Vue.set(this.mutableMenuConfiguration, 'theme', themeValue);
		this.$emit('update-menu-config', { theme: themeValue });
	}

	private updateDisplayColorFromPicker(evt: any): void {
		this.displayColor = evt.hex;

		Vue.set(this.mutableMenuConfiguration, 'primary_color', evt.hex);
		this.$emit('update-menu-config', { primary_color: evt.hex });
	}

	private updateDisplayColorFromInput(hexColor: string): void {
		const colorValue = this.forceHashPrefix(hexColor);
		Vue.set(this.mutableMenuConfiguration, 'primary_color', colorValue);

		// When invalid or empty, display color goes to the default one
		this.displayColor = validateHTMLColorHex(this.mutableMenuConfiguration.primary_color as string)
			? this.mutableMenuConfiguration.primary_color as string
			: this.defaultPrimaryColor;

		// Colors are valid if empty!
		if (!hexColor) {
			this.$emit('invalid-color', false);
			this.$emit('update-menu-config', { primary_color: colorValue });
		}
		else {
			const isValid = validateHTMLColorHex(this.mutableMenuConfiguration.primary_color as string);
			this.$emit('invalid-color', !isValid);

			if (isValid) {
				this.$emit('update-menu-config', { primary_color: colorValue });
			}
		}
	}

	private forceHashPrefix(hexColor: string): string {
		if (hexColor) {
			return hexColor.startsWith('#') ? hexColor : `#${hexColor}`;
		}
		return '';
	}
}
